export const QUERY_KEYS = {
  authUserInfo: 'auth_user_info',
  subscriptionsPlans: 'subscriptions_plans',
  preparePayData: 'prepare_pay_data',
  stripePaymentIntent: 'stripe_payment_intent',
  checkPaymentStatus: 'check_payment_status',
  quizState: 'quiz_state',
  profileInformation: 'profile_information',
  readSearchParams: 'read_search_params',
  token: 'token',
  subscriptionsMe: 'subscriptions_me',
  subscriptionsOfferEligibility: 'subscriptions_offer_eligibility',
  subscriptionsOffersEligibility: 'subscriptions_offers_eligibility',
  subscriptionsOfferPreview: 'subscriptions_offer_preview',
  userTester: 'user_tester',
  notifications: 'notifications',
  checkOfferCode: 'check_offer_code',
  promoCode: 'promo_code',
  quizzes: 'quizzes',
} as const;

export const KEYS_TO_REMOVE_FROM_BODY: string[] = ['password', 'transaction'];
